import { namedFlavor } from '@protomaps/basemaps';
import L from 'leaflet';
import 'leaflet-fullscreen';
import * as protomapsL from 'protomaps-leaflet';

$(document).ready(function () {
	// Credit: https://github.com/mutsuyuki/Leaflet.SmoothWheelZoom?tab=readme-ov-file
	L.Map.mergeOptions({
		// @section Mousewheel options
		// @option smoothWheelZoom: Boolean|String = true
		// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
		// it will zoom to the center of the view regardless of where the mouse was.
		smoothWheelZoom: true,

		// @option smoothWheelZoom: number = 1
		// setting zoom speed
		smoothSensitivity: 1

	});


	L.Map.SmoothWheelZoom = L.Handler.extend({

		addHooks: function () {
			L.DomEvent.on(this._map._container, 'wheel', this._onWheelScroll, this);
		},

		removeHooks: function () {
			L.DomEvent.off(this._map._container, 'wheel', this._onWheelScroll, this);
		},

		_onWheelScroll: function (e) {
			if (!this._isWheeling) {
				this._onWheelStart(e);
			}
			this._onWheeling(e);
		},

		_onWheelStart: function (e) {
			var map = this._map;
			this._isWheeling = true;
			this._wheelMousePosition = map.mouseEventToContainerPoint(e);
			this._centerPoint = map.getSize()._divideBy(2);
			this._startLatLng = map.containerPointToLatLng(this._centerPoint);
			this._wheelStartLatLng = map.containerPointToLatLng(this._wheelMousePosition);
			this._startZoom = map.getZoom();
			this._moved = false;
			this._zooming = true;

			map._stop();
			if (map._panAnim) map._panAnim.stop();

			this._goalZoom = map.getZoom();
			this._prevCenter = map.getCenter();
			this._prevZoom = map.getZoom();

			this._zoomAnimationId = requestAnimationFrame(this._updateWheelZoom.bind(this));
		},

		_onWheeling: function (e) {
			var map = this._map;

			this._goalZoom = this._goalZoom + L.DomEvent.getWheelDelta(e) * 0.003 * map.options.smoothSensitivity;
			if (this._goalZoom < map.getMinZoom() || this._goalZoom > map.getMaxZoom()) {
				this._goalZoom = map._limitZoom(this._goalZoom);
			}
			this._wheelMousePosition = this._map.mouseEventToContainerPoint(e);

			clearTimeout(this._timeoutId);
			this._timeoutId = setTimeout(this._onWheelEnd.bind(this), 200);

			L.DomEvent.preventDefault(e);
			L.DomEvent.stopPropagation(e);
		},

		_onWheelEnd: function (e) {
			this._isWheeling = false;
			cancelAnimationFrame(this._zoomAnimationId);
			this._map._moveEnd(true);
		},

		_updateWheelZoom: function () {
			var map = this._map;

			if ((!map.getCenter().equals(this._prevCenter)) || map.getZoom() != this._prevZoom)
				return;

			this._zoom = map.getZoom() + (this._goalZoom - map.getZoom()) * 0.3;
			this._zoom = Math.floor(this._zoom * 100) / 100;

			var delta = this._wheelMousePosition.subtract(this._centerPoint);
			if (delta.x === 0 && delta.y === 0)
				return;

			if (map.options.smoothWheelZoom === 'center') {
				this._center = this._startLatLng;
			} else {
				this._center = map.unproject(map.project(this._wheelStartLatLng, this._zoom).subtract(delta), this._zoom);
			}

			if (!this._moved) {
				map._moveStart(true, false);
				this._moved = true;
			}

			map._move(this._center, this._zoom);
			this._prevCenter = map.getCenter();
			this._prevZoom = map.getZoom();

			this._zoomAnimationId = requestAnimationFrame(this._updateWheelZoom.bind(this));
		}

	});

	L.Map.addInitHook('addHandler', 'smoothWheelZoom', L.Map.SmoothWheelZoom);

	// Shared constants
	const PMTILES_URL = 'https://d34qbj4pwbvlq5.cloudfront.net/vector/am_australia_20250702.pmtiles';
	const OSM_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

	// Override the light flavor to soften the Woomera Prohibited Area ('military')
	// rendering, which uses the `zoo` colour from the style.
	const amLight = { ...namedFlavor("light"), zoo: "rgba(210, 239, 207, 0.4)" };

	// Regular maps
	$('.js-leaflet-map').each(function (index, element) {
		const lat = parseFloat($(element).data('lat'));
		const lng = parseFloat($(element).data('lng'));
		const zoom = parseInt($(element).data('zoom'));

		const map = L.map(element, {
			center: [lat, lng],
			zoom: zoom,
			minZoom: 2,
			attributionControl: false, // disable default attribution to customize it
			scrollWheelZoom: false, // disable original zoom function
			smoothWheelZoom: true,  // enable smooth zoom
			smoothSensitivity: 20  // enable sensitive zoom
		});

		// Add custom attribution control without Ukrainian flag
		L.control.attribution({
			position: 'bottomright',
			prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">Leaflet</a>'
		}).addTo(map);

		// Add base layer
		const baseLayer = protomapsL.leafletLayer({
			url: PMTILES_URL,
			paintRules: protomapsL.paintRules(amLight),
			labelRules: protomapsL.labelRules(amLight, 'en'),
			backgroundColor: amLight.background,
			attribution: OSM_ATTRIBUTION
		});
		baseLayer.addTo(map);

		// Add marker
		L.marker([lat, lng]).addTo(map);

		// Add fullscreen control if available
		if (L.Control.Fullscreen) {
			map.addControl(new L.Control.Fullscreen({
				position: 'topleft'
			}));
		}
	});

	// ALA maps — helper functions

	const ALA_TAXA_BASE_URL = 'https://biodiversity.org.au/afd/taxa/';
	const ALA_COUNT_API_URL = 'https://api.ala.org.au/occurrences/occurrences/taxaCount';
	const DEFAULT_SAMPLE_COUNT = 1000;

	const AFD_TAXON_UUID_REGEX = /afd\.taxon:([0-9a-fA-F-]+)/;
	/**
	 * Fetch the total occurrence count for a species from the ALA API.
	 * Returns DEFAULT_SAMPLE_COUNT on failure.
	 * API response shape: { "https://biodiversity.org.au/afd/taxa/<uuid>": <number> }
	 *
	 * `speciesIdentifier` may be:
	 *   - an LSID like "urn:lsid:...:afd.taxon:<uuid>"
	 *   - a plain "<uuid>"
	 *   - a full AFD URL "https://biodiversity.org.au/afd/taxa/<uuid>"
	 */
	async function getSampleCountForSpecies(speciesIdentifier) {
		let speciesUrl;
		// If we get an LSID, extract the AFD taxon UUID and build the expected AFD URL.
		const lsidMatch = typeof speciesIdentifier === 'string'
			? speciesIdentifier.match(AFD_TAXON_UUID_REGEX)
			: null;
		if (lsidMatch && lsidMatch[1]) {
			speciesUrl = ALA_TAXA_BASE_URL + lsidMatch[1];
		} else if (typeof speciesIdentifier === 'string' && speciesIdentifier.startsWith('http')) {
			// Allow callers to pass a full URL directly.
			speciesUrl = speciesIdentifier;
		} else {
			// Backwards-compatible fallback: treat as bare identifier appended to the base URL.
			speciesUrl = ALA_TAXA_BASE_URL + speciesIdentifier;
		};
		const url = `${ALA_COUNT_API_URL}?guids=${encodeURIComponent(speciesUrl)}`;
		try {
			const response = await fetch(url, {
				headers: { 'accept': 'application/json' }
			});
			const data = await response.json();
			const count = data && data[speciesUrl];
			if (typeof count === 'number' && count > 0) {
				return count;
			}
		} catch (e) {
			console.warn('Failed to fetch ALA sample count, using default', e);
		}
		return DEFAULT_SAMPLE_COUNT;
	}

	/**
	 * Convert an AARRGGBB hex colour string (as used by ALA WMS) to a CSS rgba() value.
	 */
	function aarrggbbToCss(colour) {
		const aa = parseInt(colour.slice(0, 2), 16);
		const rr = parseInt(colour.slice(2, 4), 16);
		const gg = parseInt(colour.slice(4, 6), 16);
		const bb = parseInt(colour.slice(6, 8), 16);
		return `rgba(${rr},${gg},${bb},${(aa / 255).toFixed(2)})`;
	}

	/**
	 * Format a number for compact display in the map legend.
	 */
	function formatLegendNumber(count) {
		if (count >= 1000) return `${Math.round(count / 1000)}k`;
		return String(count);
	}

	/**
	 * Build labels like 0-5, 6-50, ..., 501+ from bin thresholds.
	 * Thresholds use `<=` semantics (count <= threshold uses that colour).
	 */
	function buildLegendLabels(colourBins) {
		let lowerBound = 0;
		return colourBins.map((bin) => {
			if (typeof bin.count === 'number') {
				const upperBound = bin.count;
				const label = `${formatLegendNumber(lowerBound)}-${formatLegendNumber(upperBound)}`;
				lowerBound = bin.count + 1;
				return label;
			}
			return `${formatLegendNumber(lowerBound)}+`;
		});
	}

	/**
	 * Build the ALA WMS colour-break bins as structured data.
	 * Returns an array of { aarrggbb, csscol, count } objects.
	 * `count` is the upper threshold for each bin (null for the last/highest bin).
	 * Scales bin thresholds relative to the square root of the total sample count.
	 * Colours are in AARRGGBB format as required by the ALA WMS ENV parameter.
	 * Inspired by: https://github.com/AtlasOfLivingAustralia/ala-datastories
	 */
	function buildColourBins(sampleCount) {
		// Scale with square root of total records for a balanced gradient
		let maxCount = Math.sqrt(sampleCount) * 12;
		if (maxCount > 10000) {
			maxCount = Math.floor(maxCount / 1000) * 1000;
		} else if (maxCount > 1000) {
			maxCount = Math.floor(maxCount / 100) * 100;
		}

		const binDivisors = [1000, 100, 10, 1, 1];
		const binColours = ['88FFFF00', '88FFCC00', '99FF9900', 'CCFF6600', 'FFD60A00'];
		const candidateBins = binColours.map((colour, i) => ({
			aarrggbb: colour,
			csscol: aarrggbbToCss(colour),
			// Last bin has no upper threshold
			count: i < binColours.length - 1 ? Math.floor(maxCount / binDivisors[i]) : null,
		}));

		// Drop any non-increasing thresholds (including <= 0), because in ALA WMS
		// these would create unreachable legend bins (for example <= 0).
		let lastCount = 0;
		const colourBins = candidateBins.filter((bin) => {
			if (typeof bin.count !== 'number') {
				return true;
			}
			if (bin.count <= lastCount) {
				return false;
			}
			lastCount = bin.count;
			return true;
		});

		return colourBins;
	}

	/**
	 * Build the ALA WMS colour-break string for hexbin rendering.
	 */
	function buildColourString(sampleCount) {
		return buildColourBins(sampleCount)
			.map((bin) => bin.count !== null ? `${bin.aarrggbb},${bin.count}` : bin.aarrggbb)
			.join(',');
	}

	// ALA maps — map initialisation

	$('.js-leaflet-ala-map').each(async function (index, element) {
		const rawLsidName = $(element).data('lsid-name');
		// If lsidName is missing or empty (e.g. when skip_map_loading is true), skip initialising this map
		// we anticipate this will be caught by the editors before publishing, but this check adds some resilience
		// in case of mistakes
		if (typeof rawLsidName !== 'string' || !rawLsidName.trim()) {
			return;
		}
		const lsidName = rawLsidName.trim();
		const speciesIdentifier = lsidName.split('/').pop();

		const map = L.map(element, {
			minZoom: 2,
			attributionControl: false,
			scrollWheelZoom: false,
			smoothWheelZoom: true,
			smoothSensitivity: 20
		});

		L.control.attribution({
			position: 'bottomright',
			prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">Leaflet</a>'
		}).addTo(map);

		// Set bounds to Australia, with padding scaled to container size
		// so the whole country is visible even on narrow screens
		const australiaBounds = L.latLngBounds(
			[-44, 112],  // Southwest corner (full aus)
			[-9, 159]    // Northeast corner
		);
		function fitAustralia() {
			const containerWidth = element.clientWidth;
			const pad = containerWidth < 600 ? 20 : 40;
			map.fitBounds(australiaBounds, { padding: [pad, pad] });
		}
		fitAustralia();
		window.addEventListener('resize', function () {
			map.invalidateSize();
			fitAustralia();
		});

		// Add base layer
		const baseLayer = protomapsL.leafletLayer({
			url: PMTILES_URL,
			paintRules: protomapsL.paintRules(amLight),
			labelRules: protomapsL.labelRules(amLight, 'en'),
			backgroundColor: amLight.background,
			attribution: OSM_ATTRIBUTION
		});
		baseLayer.addTo(map);

		// Fetch species count then add the ALA hexbin layer with appropriate colour breaks
		const sampleCount = await getSampleCountForSpecies(speciesIdentifier);
		const colourBins = buildColourBins(sampleCount);
		const colourString = buildColourString(sampleCount);
		const legendLabels = buildLegendLabels(colourBins);

		// Add a legend in the bottom-right corner showing the hexbin colour scale
		const legend = L.control({ position: 'bottomright' });
		legend.onAdd = function () {
			const div = L.DomUtil.create('div', 'leaflet-ala-legend');
			[...colourBins].reverse().forEach((bin, i, arr) => {
				const chip = L.DomUtil.create('div', 'leaflet-ala-legend__chip', div);
				if (i < arr.length - 1) chip.style.marginBottom = '3px';
				const swatch = L.DomUtil.create('span', 'leaflet-ala-legend__swatch', chip);
				swatch.style.background = bin.csscol;
				const label = L.DomUtil.create('span', 'leaflet-ala-legend__label', chip);
				const originalIndex = colourBins.length - 1 - i;
				label.textContent = legendLabels[originalIndex];
			});
			return div;
		};
		legend.addTo(map);


		L.tileLayer.wms('https://biocache.ala.org.au/ws/ogc/wms/reflect', {
			format: 'image/png',
			transparent: true,
			q: `lsid:${lsidName}`,
			ENV: `size:1;colormode:hexbin;color:${colourString}`,
			attribution: 'Atlas of Living Australia',
			SERVICE: 'WMS',
			REQUEST: 'GetMap',
			VERSION: '1.1.1',
			SRS: 'EPSG:3857',
			FORMAT: 'image/png',
			BGCOLOR: '0x000000',
			TRANSPARENT: true,
			OUTLINE: false,
			WIDTH: 256,
			HEIGHT: 256,
			TYPE: 'raster',
			TILESIZE: 256
		}).addTo(map);

		if (L.Control.Fullscreen) {
			map.addControl(new L.Control.Fullscreen({
				position: 'bottomleft'
			}));
		}
	});
});
